import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemIcon, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    container: {
        paddingLeft: 8,
        paddingRight: 8,
        marginBottom: 4
    },
    iconPopover: {
        minWidth: 30
    },
    titlePopover: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        marginTop: 4
    },
});

function ListItemPopoverItem({ label, onClick, icon: IconComponent }) {
    const classes = useStyles();

    return (
        <ListItem button onClick={onClick} className={classes.container}>
            <ListItemIcon className={classes.iconPopover}>
                <IconComponent />
            </ListItemIcon>
            <Typography className={classes.titlePopover}>{label}</Typography>
        </ListItem>
    )
}

ListItemPopoverItem.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.object
}

export default ListItemPopoverItem;
